import styled from "styled-components";

export const VerLabel = styled.div`
font-size: 12px;
color: #00447C;
margin-left: auto;
`